// extracted by mini-css-extract-plugin
export default {"container":"hoGjrtvG0nk0rQYoXMu6","avatar":"tFli1tOb8lqw2RFnbPTA","certificationIcon":"S_T3kJWakSm__GeUV8Zj"};